module.exports = __webpack_public_path__ + "img/FPS@3x.8e5ea656.png";